import React from 'react';
import Fade from 'react-reveal/Fade';
import { StyledServices, StyledPreviewGridWrapper } from './Services.style';
import ServicesGridItem from './ServicesGridItem';
import SectionTitle from '../../../SectionTitle.style';

// const commercialText = 'We produce beautiful, effective commercial productions across a wide range of industry sectors and brands for television or web video distribution. We work closely with our clients to understand their message objectives to create the best concept with the highest production values.';
// const creativityText = 'It all starts with the idea as video production is more than just producing a cool video. Our team works with the client to brainstorm ideas, keeping all marketing goals in mind to create vibrant and effective concepts that will cater to the right audience.';
// const collaborateText = 'Content that deliver results. Corporate video production services at Creative Officials are unique as our team focus on making your corporate video production runs as smooth as possible and on budget with professional grade cameras, lighting, and sound.';
// const musicVideoText = 'Whether you’re an unsigned artist or a large record label, we can help you promote your music by producing a stylish, unique music video. We have filmed music videos, bringing a fresh and out-of-the-box approach to each of our projects.';

const creativityText = 'It all starts with the idea. Our team will work with you to brainstorm the best ideas to create vibrant and effective concepts that will cater to your audience.';
const collaborateText = 'Our team focus on making your corporate video production runs as smooth as possible and on budget with professional-grade cameras, lighting, and sound. Our content delivers results.';
const commercialText = 'We produce effective content across a wide range of industry sectors and brands for television and web. With the highest production values, we will make sure to prioritize your message objectives.';
const musicVideoText = 'Whether you are an unsigned artist or a large record label, we can help you promote your music by creating a stylish, unique, out-of-the-box music video';

function Services() {
  return (
    <StyledServices id="services">
      <div className="parallax">
        <div className="image" />
        <SectionTitle> Our services </SectionTitle>
        <Fade bottom delay={500} duration={1000}>
          <StyledPreviewGridWrapper>
            <ServicesGridItem iconUrl="../img/preview2.svg" title="Creativity" text={creativityText} />
            <ServicesGridItem iconUrl="../img/preview1.svg" title="Collaboration" text={collaborateText} />
            <ServicesGridItem iconUrl="../img/preview3.svg" title="Commercials" text={commercialText} />
            <ServicesGridItem iconUrl="../img/preview4.svg" title="Music Videos" text={musicVideoText} />
          </StyledPreviewGridWrapper>
        </Fade>
      </div>
    </StyledServices>
  );
}

export default Services;
